import request from '@/utils/request.js'

//优惠券列表
export function couponList(){
    return request({
        url: '/public/coupons',
        method: 'GET',
    })
}

//商品可用优惠券列表
export function goodsCouponsList(params) {
    return request({
        url: '/public/goods-coupons',
        method: 'GET',
        params
    })
}

//购物车可用优惠券列表
export function cartCouponList(data) {
    return request({
        url: '/public/goods-list-coupons',
        method: 'POST',
        data
    })
}
